import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { SharedActionsBaseService } from '@fi-app/shared/fi-shared-services/shared-actions-base.service';
import { ITaskV2ChecklistDataBase } from '@fi-app/task-v2/fi-task-v2';
import { Checkpoint2StatusType } from '@fi-shared/checklist/checklist-enum';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';

@Component({
    selector: 'fi-task-v2-intro',
    templateUrl: './fi-task-v2-intro.component.html',
    styleUrls: ['./fi-task-v2-intro.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-intro' },
    standalone: false,
})
export class FiTaskV2IntroComponent {
    @Input() checklistData: ITaskV2ChecklistDataBase;

    constructor(
        private sharedActionsService: SharedActionsBaseService,
        private fiTaskV2HelperService: FiTaskV2HelperService,
    ) {}

    protected isCheckpointAnswerSkipped(): boolean {
        return this.checklistData.CheckpointAnswerStatus === Checkpoint2StatusType.NotFilledOut;
    }

    protected openBusinessUnit(businessUnitId: number): void {
        this.sharedActionsService.openUnitViewPopup(businessUnitId);
    }

    protected openUser(userId: number): void {
        this.sharedActionsService.openUserViewPopup(userId);
    }

    protected openChecklist(): void {
        if (this.fiTaskV2HelperService.canOpenTaskChecklistView(this.checklistData)) {
            this.fiTaskV2HelperService.openTaskChecklistView(this.checklistData);
        }
    }
}
